export default "__VITE_ASSET__CIJ3A1r___"